export enum EmployeeAdvanceSettlementSourceType {
  PAYROLL = "PAYROLL",
  MANUAL = "MANUAL",
}

export const EmployeeAdvanceSettlementSourceTypeLabel: Record<
  EmployeeAdvanceSettlementSourceType,
  string
> = {
  [EmployeeAdvanceSettlementSourceType.PAYROLL]: "Payroll",
  [EmployeeAdvanceSettlementSourceType.MANUAL]: "Manual",
};
